import axios from 'axios';
import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import * as Yup from "yup";
import Cookies from "js-cookie";
import { adminMainUrl } from '../../../../Config';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Table } from "antd";
import Beatloader from '../../../../Common/Loaders/Beatloader';
import { getMasterAirlineDetail, getMasterAirlineAddressList, getMasterIATAAgentContactList, getMasterIATAAgentCustomerList, getMasterIATAAgentSalesList } from '../../../../Redux/action/MasterAction';
import AddAddress from './Offcanvases/AddAddress';
import EditAddress from './Offcanvases/EditAddress';
import InputTextJSX from './InputTextJSX';

const AirlineEdit = ({ accessedPermission }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    let { b64id } = useParams();
    const [disableSubmit, setDisableSubmit] = useState(false);
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const [activeTab, setActiveTab] = useState("airline_master");
    const [activeContactTab, setActiveContactTab] = useState("cd_sales_person");

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        if (token && user_id) {
            if (b64id) {
                let airline_id = atob(b64id);
                if (airline_id) {
                    dispatch(getMasterAirlineDetail(token, user_id, airline_id));
                    dispatch(getMasterAirlineAddressList(token, user_id, airline_id));
                    // dispatch(getMasterIATAAgentSalesList(token, user_id, airline_id));
                    // dispatch(getMasterIATAAgentCustomerList(token, user_id, airline_id));
                    // dispatch(getMasterIATAAgentContactList(token, user_id, airline_id));
                }
            } else {
                toast.error("Please enter correct URL.");
                navigate(-1);
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, b64id]);


    //handle modal offcanvas

    const [address_id, setAddress_id] = useState(0);

    const [showAddAddress, setShowAddAddress] = useState(false);
    const handleAddAddressClose = () => setShowAddAddress(false);
    const handleAddAddressShow = () => setShowAddAddress(true);

    const [showEditAddress, setShowEditAddress] = useState(false);
    const handleEditAddressClose = () => setShowEditAddress(false);
    const handleEditAddressShow = (id) => {
        if (id) {
            setAddress_id(id);
            setShowEditAddress(true);
        } else {
            toast.error("Couldn't find addresss.")
        }
    }


    const {
        loadingMasterIATAAgentList,
        MasterIATAAgentList,
        MasterIATAAgentListError,
        MasterIATAAgentListCurrentPage,
        MasterIATAAgentListTotalPage,
        MasterIATAAgentListTotalData,

        loadingMasterAirlineDetail,
        MasterAirlineDetail,
        MasterAirlineDetailError,

        loadingMasterAirlineAddressList,
        MasterAirlineAddressList,
        MasterAirlineAddressListError,

        loadingMasterIATAAgentSalesList,
        MasterIATAAgentSalesList,
        MasterIATAAgentSalesListError,

        loadingMasterIATAAgentCustomerList,
        MasterIATAAgentCustomerList,
        MasterIATAAgentCustomerListError,

        loadingMasterIATAAgentContactList,
        MasterIATAAgentContactList,
        MasterIATAAgentContactListError,

    } = useSelector(state => state.MasterReducer);

    const refresh = () => {
        if (token && user_id) {
            if (b64id) {
                let airline_id = atob(b64id);
                if (airline_id) {
                    dispatch(getMasterAirlineDetail(token, user_id, airline_id));
                }
            } else {
                toast.error("Please enter correct URL.");
                navigate(-1);
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    };
    const refreshAddress = () => {
        if (token && user_id) {
            if (b64id) {
                let airline_id = atob(b64id);
                if (airline_id) {
                    dispatch(getMasterAirlineAddressList(token, user_id, airline_id));
                }
            } else {
                toast.error("Please enter correct URL.");
                navigate(-1);
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    };
  

    useEffect(() => {
        if (loadingMasterAirlineDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
    }, [loadingMasterAirlineDetail]);

    const initialValues = {
        name: "",
        international_code: "",
        international_awb_perfix: "",
        international_awb_format: "",
        domestic_code: "",
        domestic_awb_perfix: "",
        domestic_awb_format: "",
        is_iata: false,
        pan_number: "",
        pima_code: "",
        account_number: "",
        commission_type: "",
        commission_rate: "",
        two_digit_code: "",
        three_digit_code: "",
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({
            // name: Yup.string().required("Please enter name")
        }),
        onSubmit: (values, { resetForm }) => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }
                let airline_id = atob(b64id);
                if (airline_id) {
                    values.id = Number(airline_id)
                } else {
                    toast.error("Could not find IATA agent.");
                    return;
                }
                axios.post(`${adminMainUrl}/api/master/airline/edit`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refresh();
                            // navigate(`/flexichain/organization/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    useEffect(() => {
        if (MasterAirlineDetail) {
            formik.setFieldValue("name", MasterAirlineDetail.name ?? "")
            formik.setFieldValue("international_code", MasterAirlineDetail.international_code ?? "")
            formik.setFieldValue("international_awb_perfix", MasterAirlineDetail.international_awb_perfix ?? "")
            formik.setFieldValue("international_awb_format", MasterAirlineDetail.international_awb_format ?? "")
            formik.setFieldValue("domestic_code", MasterAirlineDetail.domestic_code ?? "")
            formik.setFieldValue("domestic_awb_perfix", MasterAirlineDetail.domestic_awb_perfix ?? "")
            formik.setFieldValue("domestic_awb_format", MasterAirlineDetail.domestic_awb_format ?? "")
            formik.setFieldValue("is_iata", MasterAirlineDetail.is_iata ?? false)
            formik.setFieldValue("pan_number", MasterAirlineDetail.pan_number ?? "")
            formik.setFieldValue("pima_code", MasterAirlineDetail.pima_code ?? "")
            formik.setFieldValue("account_number", MasterAirlineDetail.account_number ?? "")
            formik.setFieldValue("commission_type", MasterAirlineDetail.commission_type ?? "")
            formik.setFieldValue("commission_rate", MasterAirlineDetail.commission_rate ?? "")
            formik.setFieldValue("two_digit_code", MasterAirlineDetail.two_digit_code ?? "")
            formik.setFieldValue("three_digit_code", MasterAirlineDetail.three_digit_code ?? "")
        }
    }, [MasterAirlineDetail]);


    const columnsAddress = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "Default", dataIndex: "is_default", key: "is_default" },
        { title: "Address 1", dataIndex: "address_one", key: "address_one" },
        { title: "Address 2", dataIndex: "address_two", key: "address_two" },
        { title: "City", dataIndex: "city", key: "city" },
        { title: "State", dataIndex: "state", key: "state" },
        { title: "Country", dataIndex: "country", key: "country" },
        { title: "Pin Code", dataIndex: "pincode", key: "pincode" },
        { title: "Contact Person", dataIndex: "contact_person_name", key: "contact_person_name" },
        // { title: "Mobile No.", dataIndex: "mobile_no", key: "mobile_no" },
        { title: "GST State Name", dataIndex: "gst_state_name", key: "gst_state_name" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];

    

    const [dataSourceAddress, setDataSourceAddress] = useState([]);

    useEffect(() => {
        // console.log("MasterAirlineAddressList",MasterAirlineAddressList);
        if (MasterAirlineAddressList) {
            let arr = [];
            MasterAirlineAddressList.map((val, index) => {
                arr.push({
                    sno: index + 1,
                    is_default: val.is_default ? "YES" : "NO",
                    address_one: val.address_one ?? "-",
                    address_two: val.address_two ?? "-",
                    city: val.airline_city ? val.airline_city.name : "-",
                    state: val.airline_state ? val.airline_state.name : "-",
                    country: val.airline_country ? val.airline_country.name : "-",
                    pincode: val.pincode ?? "-",
                    contact_person_name: val.contact_person_name ?? "-",
                    // mobile_no: val.mobile ?? "-",
                    gst_state_name: val.airline_gst_state ? val.airline_gst_state.name : "-",
                    action: (
                        <>
                            <div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                    <div className="dropdown-item cursor-pointer" onClick={() => handleEditAddressShow(val.id)} >
                                        <i className="ti ti-edit text-blue me-2"></i> Edit Address
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                })
            });
            setDataSourceAddress(arr);
        } else {
            setDataSourceAddress([]);
        }
    }, [MasterAirlineAddressList]);

    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <div className="page-wrapper">
                        <div className="content">
                            <div className="row">
                                <h4>Edit Airline</h4>
                            </div>
                            <div className="row-gap-2">
                                <div className="tab-content" id="pills-tabContent">
                                    <Tabs
                                        activeKey={activeTab} // Controlled by state
                                        onSelect={(k) => setActiveTab(k)} // Update state on tab change
                                        transition={false}
                                        id="noanim-tab-example"
                                        className="nav nav-pills mb-3 custom-tabs gap-0"
                                    >
                                        <Tab eventKey="airline_master" title="Airline Master" className="nav-item" disabled={false}>
                                            <div className="card">
                                                <div className="card-body">
                                                    {/* Filter */}
                                                    <form onSubmit={formik.handleSubmit}>
                                                        <div className="row">
                                                            <InputTextJSX
                                                                labelText={"Airline Name"}
                                                                nameValue={"name"}
                                                                value={formik.values.name}
                                                                onChange={formik.handleChange}
                                                                maxLength={100}
                                                            />
                                                            <div className={`col-md-6 mt-2`}>
                                                                <div className='ms-2'>
                                                                    <label htmlFor="" className='form-label  mb-0'>
                                                                        3 Digit Code
                                                                    </label>
                                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                                        <input
                                                                            type="text"
                                                                            maxLength={3}
                                                                            className="form-control form-control-sm"
                                                                            id={"three_digit_code"}
                                                                            name={"three_digit_code"}
                                                                            value={formik.values.three_digit_code}
                                                                            onChange={formik.handleChange}
                                                                            onInput={(event) => {
                                                                                let value = event.target.value;
                                                                                value = value.replace(/[^0-9]/g, '');
                                                                                event.target.value = value;
                                                                            }}

                                                                        // onBlur={formik.handleBlur}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className={`col-md-6 mt-2`}>
                                                                <div className='ms-2'>
                                                                    <label htmlFor="" className='form-label  mb-0'>
                                                                        2 Digit Code
                                                                    </label>
                                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                                        <input
                                                                            type="text"
                                                                            maxLength={2}
                                                                            className="form-control form-control-sm"
                                                                            id={"two_digit_code"}
                                                                            name={"two_digit_code"}
                                                                            value={formik.values.two_digit_code}
                                                                            onChange={formik.handleChange}
                                                                        // onInput={(event) => {
                                                                        //     let value = event.target.value;
                                                                        //     value = value.replace(/[^0-9]/g, '');
                                                                        //     event.target.value = value;
                                                                        // }}

                                                                        // onBlur={formik.handleBlur}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className={`col-md-6 mt-2`}>
                                                                <div className='ms-2'>
                                                                    <label htmlFor="" className='form-label  mb-0'>
                                                                        Commission Rate
                                                                    </label>
                                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                                        <input
                                                                            type="text"
                                                                            maxLength={10}
                                                                            className="form-control form-control-sm"
                                                                            id={"commission_rate"}
                                                                            name={"commission_rate"}
                                                                            value={formik.values.commission_rate}
                                                                            onChange={formik.handleChange}
                                                                            onInput={(event) => {
                                                                                let value = event.target.value;
                                                                                value = value.replace(/[^0-9]/g, '');
                                                                                event.target.value = value;
                                                                            }}
                                                                        // onBlur={formik.handleBlur}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className={`col-md-6 mt-2`}>
                                                                <div className='ms-2'>
                                                                    <label htmlFor="" className='form-label  mb-0'>
                                                                        Comission Type
                                                                    </label>
                                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                                        <select
                                                                            className="form-control form-control-sm"
                                                                            id={"commission_type"}
                                                                            name={"commission_type"}
                                                                            value={formik.values.commission_type}
                                                                            onChange={formik.handleChange}
                                                                        >
                                                                            <option value="">-Select an option-</option>
                                                                            <option value="NET">Net</option>
                                                                            <option value="GROSS">Gross</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <InputTextJSX
                                                                labelText={"Account No."}
                                                                nameValue={"account_number"}
                                                                value={formik.values.account_number}
                                                                onChange={formik.handleChange}
                                                                maxLength={20}
                                                            />
                                                            <InputTextJSX
                                                                labelText={"Airline Pima Code"}
                                                                nameValue={"pima_code"}
                                                                value={formik.values.pima_code}
                                                                onChange={formik.handleChange}
                                                                maxLength={35}
                                                            />
                                                            <InputTextJSX
                                                                labelText={"Pan No."}
                                                                nameValue={"pan_number"}
                                                                value={formik.values.pan_number}
                                                                onChange={formik.handleChange}
                                                                maxLength={10}
                                                            />
                                                            <InputTextJSX
                                                                labelText={"International Code"}
                                                                nameValue={"international_code"}
                                                                value={formik.values.international_code}
                                                                onChange={formik.handleChange}
                                                                maxLength={10}
                                                            />
                                                            <InputTextJSX
                                                                labelText={"International AWB Prefix"}
                                                                nameValue={"international_awb_perfix"}
                                                                value={formik.values.international_awb_perfix}
                                                                onChange={formik.handleChange}
                                                                maxLength={10}

                                                            />
                                                            <InputTextJSX
                                                                labelText={"International AWB Format"}
                                                                nameValue={"international_awb_format"}
                                                                value={formik.values.international_awb_format}
                                                                onChange={formik.handleChange}
                                                                maxLength={10}

                                                            />
                                                            <InputTextJSX
                                                                labelText={"Domestic Code"}
                                                                nameValue={"domestic_code"}
                                                                value={formik.values.domestic_code}
                                                                onChange={formik.handleChange}
                                                                maxLength={10}

                                                            />
                                                            <InputTextJSX
                                                                labelText={"Domestic AWB Prefix"}
                                                                nameValue={"domestic_awb_perfix"}
                                                                value={formik.values.domestic_awb_perfix}
                                                                onChange={formik.handleChange}
                                                                maxLength={10}

                                                            />
                                                            <InputTextJSX labelText={"Domestic AWB Format"}
                                                                nameValue={"domestic_awb_format"}
                                                                value={formik.values.domestic_awb_format}
                                                                onChange={formik.handleChange}
                                                                maxLength={10}

                                                            />

                                                            <div className={`col-md-6 mt-2 d-flex align-items-center`}>
                                                                <div className='ms-2'>
                                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="me-2"
                                                                            id="is_iata"
                                                                            name="is_iata"
                                                                            checked={formik.values.is_iata}
                                                                            onChange={(e) => {
                                                                                formik.setFieldValue("is_iata", e.target.checked);
                                                                            }}
                                                                        />
                                                                        <label htmlFor="" className='form-label  mb-0'>
                                                                            IATA
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row d-flex justify-content-end mt-2">
                                                                <div className="col-md-6 d-flex justify-content-end">
                                                                    <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                                                        {
                                                                            disableSubmit ?
                                                                                <>
                                                                                    <i className="fas fa-spinner fa-spin"></i> Saving...
                                                                                </>
                                                                                :
                                                                                "Update"
                                                                        }
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                            <div className="card">
                                                <div className='card-body'>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <h4>Address</h4>
                                                        </div>
                                                        <div className="col-md-6 text-end">
                                                            <button type='button' className="btn btn-sm btn-primary" onClick={() => { handleAddAddressShow(true) }}>
                                                                + Add Address
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="table-responsive custom-table query-list-table">
                                                        <Table className="table datanew dataTable no-footer"
                                                            dataSource={dataSourceAddress}
                                                            columns={columnsAddress}
                                                            pagination={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Tab>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                        <AddAddress
                            token={token}
                            user_id={user_id}
                            b64id={b64id}
                            show={showAddAddress}
                            handleClose={handleAddAddressClose}
                            refreshAddress={refreshAddress}
                        />

                        <EditAddress
                            address_id={address_id}
                            token={token}
                            user_id={user_id}
                            b64id={b64id}
                            show={showEditAddress}
                            handleClose={handleEditAddressClose}
                            refreshAddress={refreshAddress}
                        />
                    </div>

            }
        </>
    )
}

export default AirlineEdit